import { useUser } from "@p0security/frontend-core";
import { ContactSupport, Logo } from "@p0security/frontend-core/react";
import { Button, Flex, Result } from "@p0security/ui";

export const DisabledTenant: React.FC<{ orgSlug?: string }> = ({ orgSlug }) => {
  const { signOut } = useUser();
  return (
    <Flex justify="center" align="center">
      <Result
        title="Organization disabled due to inactivity."
        icon={<Logo logo="/p0-logo-ext.png" title="P0 Logomark" size={300} />}
        subTitle={
          <>
            Please
            <ContactSupport
              subject={`Re-enable organization${orgSlug ? " " + orgSlug : ""}`}
            />
            .
          </>
        }
        extra={
          <Button type="primary" onClick={signOut}>
            Logout
          </Button>
        }
      />
    </Flex>
  );
};
